export default {
  tags_import_title: 'Import Tags',
  tags_import_button: 'Import',
  tags_import_cancel: 'Cancel',
  tags_comma: 'Comma (,)',
  tags_semicolon: 'Semicolon (;)',
  tags_selectDelimiter: 'Select',
  tags_delimiter: 'Delimiter',
  tags_error_delimiter: 'Delimiter is required',
  tags_error_file_required: 'File is required',
  tags_import_description: 'Upload a CSV or Excel file to import tags. Make sure the file includes the required columns and follows the expected format.',
  tags_import_file_label: 'Select file to import',
  tags_import_success: 'Tags import started successfully. You will receive a notification when the process is complete.',
  tags_import_success_title: 'Import Started',
  tags_import_error_title: 'Import Error',
  tags_import_instructions: 'Important Note: The ID column is mandatory. If the import process is intended for updating existing records, perform a table export without editing the ID column value to maintain record reference. If you want to create new Tags, leave the ID column blank.',
  tags_download_template: 'Download Template',
  tags_template_labelColumn: 'Label',
  tags_template_colorColumn: 'Color (Hex format)',
  tags_template_parentlabel: 'Parent Tag',

  tags_import_error_CT01: 'Empty CSV file: The file contains no data rows. Please add at least one row with tag information.',
  tags_import_error_CT02: 'Error in CSV format - ID column and Label column are required for tag updates.',
  tags_import_error_CT03: 'No valid data rows found: Label cannot be empty in all rows.',
};